'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import I18n from 'I18n';
import { Record, List } from 'immutable';
import ActivityType from 'MeetingsBase/models/ActivityType';
import Availability from 'MeetingsBase/models/Availability';
import DisplayInfo from 'MeetingsBase/models/DisplayInfo';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
import FormField from 'MeetingsBase/models/FormField';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import Reminder from 'MeetingsBase/models/Reminder';
import { getChunkListFromRecord } from 'MeetingsBase/utils/availability';
import { FORM_FIELDS_WITH_OPTIONS } from 'MeetingsBase/constants/enums';
import { DEFAULT_LINK_CUSTOM_PARAMS } from 'MeetingsBase/constants/Defaults';

var getVisibleFormOptions = function getVisibleFormOptions(formFields) {
  return formFields.map(function (field) {
    if (FORM_FIELDS_WITH_OPTIONS.indexOf(field.type) > -1) {
      var visibleOptions = field.options.filter(function (option) {
        return !option.hidden;
      });
      field.options = visibleOptions;
    }

    return field;
  });
};

var LinkCustomParams = /*#__PURE__*/function (_Record) {
  _inherits(LinkCustomParams, _Record);

  function LinkCustomParams() {
    _classCallCheck(this, LinkCustomParams);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinkCustomParams).apply(this, arguments));
  }

  _createClass(LinkCustomParams, [{
    key: "convertToJSON",
    value: function convertToJSON() {
      var json = this.update('legalConsentOptions', function (legalConsentOptions) {
        return legalConsentOptions ? legalConsentOptions.convertToJSON() : null;
      }).toJS();
      json.pushBackTime = this.minimumNoticeTime;
      delete json.minimumNoticeTime;
      delete json.availabilityTimeList;
      return json;
    }
  }], [{
    key: "from",
    value: function from(json) {
      if (json.timezone) {
        json.timezone = I18n.moment.tz.names().includes(json.timezone) ? json.timezone : 'Europe/Dublin';
      }

      var activityType = json.activityType && json.activityType !== '' ? ActivityType.from(json.activityType) : null;
      var legalConsentOptions = json.legalConsentOptions !== null ? LegalConsentOptions.from(json.legalConsentOptions) : null;
      var availability = Availability.from(json.availability);
      return new LinkCustomParams(Object.assign({}, json, {
        activityType: activityType,
        availability: availability,
        availabilityTimeList: getChunkListFromRecord(availability),
        displayInfo: DisplayInfo.from(json.displayInfo),
        welcomeScreenInfo: WelcomeScreenInfo.from(json.welcomeScreenInfo),
        durations: List(json.durations),
        formFields: List(getVisibleFormOptions(json.formFields).map(function (field) {
          return FormField.from(field);
        })),
        legalConsentOptions: legalConsentOptions,
        ownerPrioritized: json.ownerPrioritized || false,
        minimumNoticeTime: json.pushBackTime,
        reminders: json.reminders ? List(json.reminders.map(function (reminder) {
          return new Reminder(reminder);
        })) : List(),
        videoConferenceExtensionAppId: json.videoConferenceExtensionAppId,
        videoConferenceExtensionAccountId: json.videoConferenceExtensionAccountId,
        weeksToAdvertise: json.weeksToAdvertise,
        startTimeIncrementMinutes: json.startTimeIncrementMinutes,
        confirmationEmailEnabled: json.confirmationEmailEnabled,
        pushBackTime: json.pushBackTime
      }));
    }
  }]);

  return LinkCustomParams;
}(Record(DEFAULT_LINK_CUSTOM_PARAMS));

export { LinkCustomParams as default };